import axios from "axios";
import environment from "@/environment";

const api = axios.create({ baseURL: `${environment.API}/System`});

export const systemStatus = {
	checkSystemStatus: () => api.get("/")

};

export const RAMStatus = {
	checkRAMStatus: () => api.get("/RAMStatus")
};

export const CPUStatus = {
	checkCPUStatus: () => api.get("/CPUStatus")
};

export const storageStatus = {
	checkStorageStatus: () => api.get("/storageStatus")
};

export const sqlDbStatus = {
	checkSqlDbStatus: () => api.get("/sqlDbStatus")
};


export async function FetchSystemDashboard () {
	try {
		const response = await systemStatus.checkSystemStatus();
		return { ...response.data, statusCode: response.status };
	}
	catch (error) {
		if (error.response && error.response.status === 418) {
			return {
				statusCode: error.response.status,
				problems: error.response.data.problems
			};
		}
		else {
			return {
				statusCode: 500,
				problems: ["Falha crítica de conexão"]
			};
		}
	}
}

export async function FetchRAMDashbord () {
	try {
		const response = await RAMStatus.checkRAMStatus();
		return { ...response.data, statusCode: response.status };
	}
	catch (error) {
		if (error.response && error.response.status === 418) {
			return {
				statusCode: error.response.status,
				message: error.response.data.message,
				usedRAMPercentage: error.response.data.usedRAMPercentage
			};
		}
		else {
			return {
				statusCode: 500
			};
		}
	}
}

export async function FetchCPUDashbord () {
	try {
		const response = await CPUStatus.checkCPUStatus();
		return { ...response.data, statusCode: response.status };
	}
	catch (error) {
		if (error.response && error.response.status === 418) {
			return {
				statusCode: error.response.status,
				message: error.response.data.message,
				loadPercentage: error.response.data.loadPercentage
			};
		}
		else {
			return {
				statusCode: 500
			};
		}
	}
}

export async function FetchStorageDashbord () {
	try {
		const response = await storageStatus.checkStorageStatus();
		return { ...response.data, statusCode: response.status };
	}
	catch (error) {
		if (error.response && error.response.status === 418) {
			return {
				statusCode: error.response.status,
				message: error.response.data.message,
				diskUsage: error.response.data.diskUsage
			};
		}
		else {
			return {
				statusCode: 500
			};
		}
	}
}

export async function FetchSqlDbDashboard () {
	try {
		const response = await sqlDbStatus.checkSqlDbStatus();
		return {...response.data, statusCode: response.status};
	}
	catch (error) {
		if (error.response) {
			return {
				statusCode: error.response.status
			};
		}
		else {
			return {
				statusCode: 500
			};
		}
	}
}

